<link rel="preload" href="assets/images/icon/bot.png" as="image">
<link rel="preload" href="assets/images/icon/machine.png" as="image">
<div class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
    <app-header></app-header>
    <div class="app-main">
        <!-- Menu Section --->
        <app-menus></app-menus>
        <!-- Menu section End -->
        <div class="app-main__outer">
            <div class="app-main__inner p-0">
                <div class="app-inner-layout chat-layout">
                    <div class="app-inner-layout__header text-white bg-premium-dark">
                        <div class="app-page-title">
                            <div class="page-title-wrapper">
                                <div class="page-title-heading">
                                    <div class="page-title-icon">
                                        <i class="pe-7s-chat icon-gradient bg-plum-plate"></i>
                                    </div>
                                    <div>
                                        Chatbot For User Manuals
                                        <div class="page-title-subheading">Expert Support from Your Machine's User
                                            Manual</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="app-inner-layout__wrapper">
                        <div class="app-inner-layout__content card">
                            <div class="table-responsive">
                                <div class="app-inner-layout__top-pane">
                                    <div class="pane-left">
                                        <div class="mobile-app-menu-btn">
                                            <button type="button" class="hamburger hamburger--elastic">
                                                <span class="hamburger-box">
                                                    <span class="hamburger-inner"></span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="chat-wrapper" #chatContent (scroll)="onScroll()">
                                    <div class="chat-content">
                                        <div *ngIf="chatMessagesData">
                                            <div *ngFor="let chat of chatMessages">
                                                <div class="chat-box-wrapper" *ngIf="chat.type === 'receive'">
                                                    <div>
                                                        <div class="avatar-icon-wrapper mr-1">
                                                            <div class="avatar-icon avatar-icon-lg rounded">
                                                                <img src="assets/images/icon/bot.png" loading="lazy"
                                                                    alt="">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="chat-box receivemsg"
                                                            [innerHTML]="getParsedMessage(chat.message)"></div>
                                                        <small class="opacity-6">
                                                            <i class="fa fa-calendar-alt mr-1"></i>
                                                            {{ getFormattedDate(chat.created_at) }}
                                                        </small>
                                                    </div>
                                                </div>
                                                <!-- class="float-right" -->
                                                <div class="chat-container" *ngIf="chat.type === 'send'">
                                                    <div class="chat-box-wrapper chat-box-wrapper-right">
                                                        <div>
                                                            <div class="chat-box sendmsg">{{ chat.message }}</div>
                                                            <small class="opacity-6">
                                                                <i class="fa fa-calendar-alt mr-1"></i>
                                                                {{ getFormattedDate(chat.created_at) }}
                                                            </small>
                                                        </div>
                                                        <div>
                                                            <div class="avatar-icon-wrapper ml-1">
                                                                <div class="avatar-icon avatar-icon-lg rounded">
                                                                    <img src="assets/images/icon/user.png" alt="">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="!chatMessagesData">
                                            <div class="chat-box-wrapper">
                                                <div>
                                                    <div class="avatar-icon-wrapper mr-1">
                                                        <div class="avatar-icon avatar-icon-lg rounded">
                                                            <img src="assets/images/icon/bot.png" loading="lazy" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="chat-box receivemsg">Looking for assistance? Ask me
                                                        anything to start a chat!</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="chat-input">
                                    <div class="chat-input-container">
                                        <input placeholder="What would you like to know about your machine?" type="text"
                                            class="form-control-lg form-control" [(ngModel)]="inputMessage"
                                            (keydown.enter)="submitmsg()">
                                        <input type="hidden" class="form-control-lg form-control"
                                            [(ngModel)]="assistantID">
                                        <button class="send-button" (click)="submitmsg()">
                                            <i class="fa fa-paper-plane"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="app-inner-layout__sidebar card">
                            <div class="app-inner-layout__sidebar-header">
                                <ul class="nav flex-column">
                                    <li class="nav-item-header nav-item">Projects</li>
                                </ul>
                            </div>
                            <ul class="nav flex-column">
                                <li class="nav-item" *ngFor="let item of soList">
                                    <button type="button" tabindex="0" class="dropdown-item"
                                        [class.active]="item.id === projectID"
                                        (click)="selectProject(item.id,item.assistant_id)">
                                        <div class="widget-content p-0">
                                            <div class="widget-content-wrapper">
                                                <div class="widget-content-left mr-3">
                                                    <div class="avatar-icon-wrapper">
                                                        <div class="avatar-icon">
                                                            <img src="assets/images/icon/machine.png" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="widget-content-left">
                                                    <div class="widget-heading">{{ item.name }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="app-drawer-overlay d-none animated fadeIn"></div>